import * as React from 'react';

import ArticleEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/ArticleEntityCard';
import EntityCardPlaceholder from 'bundles/unified-seo-content-common/components/entity-cards/EntityCardPlaceholder';
import { ENTITY_TYPES } from 'bundles/unified-seo-content-common/constants';
import useEntityCardData from 'bundles/unified-seo-content-common/hooks/useEntityCardData';
import useEntityCardLink from 'bundles/unified-seo-content-common/hooks/useEntityCardLink';
import { getEntityTypeLabel } from 'bundles/unified-seo-content-common/utils';
import { getMastertrackQueryConfig } from 'bundles/unified-seo-content-common/utils/entityCardDataQueryUtils';

import _t from 'i18n!nls/articles';

type InputProps = {
  slug: string;
};

type Props = InputProps;

const MasterTrackEntityCard = ({ slug }: Props) => {
  const { data: masterTrackMetadata, loading } = useEntityCardData(getMastertrackQueryConfig(slug));
  const cardLink = useEntityCardLink({ entityType: ENTITY_TYPES.mastertrack, slug });

  if (loading) {
    return <EntityCardPlaceholder />;
  }

  if (
    !masterTrackMetadata ||
    !masterTrackMetadata.name ||
    !masterTrackMetadata.bannerImage ||
    !masterTrackMetadata?.partners?.elements[0]?.name
  ) {
    return null;
  }

  const articleEntityCardProps = {
    title: masterTrackMetadata?.name,
    subtitle: masterTrackMetadata?.partners.elements[0].name,
    label: getEntityTypeLabel(ENTITY_TYPES.mastertrack),
    imageSrc: masterTrackMetadata?.bannerImage,
    imageAlt: 'Entity Photo',
    ctaHref: cardLink,
    ctaLabel: _t('Learn More'),
  };

  return <ArticleEntityCard {...articleEntityCardProps} />;
};

export default MasterTrackEntityCard;
